import DOMPurify from 'dompurify';
import type { Directive, DirectiveBinding } from 'vue';

export const sanitizedHtmlDirectiveArguments: [string, Directive] = [
  'sanitized-html',
  (el: HTMLElement, { value }: DirectiveBinding) => {
    el.innerHTML = DOMPurify.sanitize(value, {
      ALLOWED_TAGS: ['b', 'i', 'strong', 'a', 'em', 'br'],
      ALLOWED_ATTR: ['href', 'target'],
    });
  },
];
